import PivotGridRowProps from './Rows'

let KendoPivotGridRow = {
    name: 'kendo-pivot-row',
    render () {
        return null
    },
    mixins: [PivotGridRowProps]
}

export default KendoPivotGridRow


// WEBPACK FOOTER //
// ./packages/kendo-datasource-vue-wrapper/src/KendoPivotRow/index.js